import { CountWithComparison } from '@/models';

export const getCountChange = (count: CountWithComparison, changeNotInPercentageValue?: boolean): number | null => {
  if (count?.previous === 0 || !count || (count.current === 0 && count.previous === 0)) {
    return null;
  }
  return changeNotInPercentageValue
    ? count.current - count.previous
    : (count.current - count.previous) / count.previous;
};
